import React from 'react';
import classnames from 'classnames';
import SectionTitle from '../SectionTitle/SectionTitle';
import styles from './ComparisonSection.module.scss';
import Link from '../common/Link/Link';

const CheckIcon = () => <img src="/icons/CheckIcon.svg" alt="Check icon" />;

const ComparisonSection = () => (
  <div className={styles.container}>
    <SectionTitle>Comparison of ADDY Vesting, Stake and Lock for Boost</SectionTitle>
    <p>
      Vested, Staked, and Locked for Boost ADDY all earn the same % of performance fees. This means
      that 1 vested or staked ADDY will earn the same % of the performance fee as 1 locked for boost
      ADDY.
    </p>
    <div className={styles.comparisonWrapper}>
      <div className={classnames(styles.rowHeaders, styles.textWrapper)}>
        <span>Lock duration</span>
        <span>Early withdrawal penalty</span>
        <span>Earn performance fees in WMATIC</span>
        <span>Earn early withdrawal penalty fees</span>
        <span>Boost ADDY earnings in Vaults</span>
      </div>
      <div className={styles.card}>
        <h5 className={styles.cardTitle}>Vesting</h5>
        <div className={styles.textWrapper}>
          <span>90 days</span>
          <span>50%</span>
          <span>
            <CheckIcon />
          </span>
          <span>-</span>
          <span>-</span>
        </div>
      </div>
      <div className={styles.card}>
        <h5 className={styles.cardTitle}>Stake</h5>
        <div className={styles.textWrapper}>
          <span>-</span>
          <span>No penalty</span>
          <span>
            <CheckIcon />
          </span>
          <span>-</span>
          <span>-</span>
        </div>
      </div>
      <div className={classnames(styles.card, styles.cardBig)}>
        <h5 className={styles.cardTitle}>
          Lock for <b>Boost</b>
        </h5>
        <div className={styles.textWrapper}>
          <span>91 days - 4 years</span>
          <span>Cannot withdraw at all</span>
          <span>
            <CheckIcon />
          </span>
          <span>
            <CheckIcon />
          </span>
          <span>
            <CheckIcon />
          </span>
        </div>
      </div>
    </div>
    <div className={styles.linkWrapper}>
      <Link
        href="https://adamantfinance.gitbook.io/adamant-finance/guides/comparison-of-vesting-staking-locking"
        newTab
        color="primary"
      >
        Read more in our Documentation
      </Link>
    </div>
  </div>
);

export default ComparisonSection;
